export const toBoolean = (b: any): boolean => {
  if (b == null) return null
  if (typeof b === 'string') {
    if (b === 'true') return true
    if (b === 'false') return false
  }
  return !!b
}
